import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Misc from "../../../misc/misc";

export default class TimeTableView extends React.Component {
    static propTypes = {
        timeChanged: PropTypes.func,
        time: PropTypes.number,
        aptType: PropTypes.string,
        date: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            startTime: 9, // 9am
            endTime: 17, // 5pm
            selectedTime: this.props.time,
            aptType: this.props.aptType // apt | home-estimate
        };
    }

    handleTimeClick = (time, e) => {
        Misc.ignoreDefault(e);
        this.setState({selectedTime: time});
        this.props.timeChanged(time, this.state.aptType);
    };

    handleAptTypeClick = (aptType, e) => {
        Misc.ignoreDefault(e);
        this.setState({aptType: aptType});
        this.props.timeChanged(this.state.selectedTime, aptType);
    };

    render() {
        let date = this.props.date.format('Do');
        const postFix = date.slice(-2);
        date = date.replace(postFix, '');
        return (
            <div className="confirmation-time-wrapper">
                <div className="confirmation-time-header">
                    <div className="confirmation-time-header-number">{date}</div>
                    <div className="confirmation-time-header-info-wrapper">
                        <div className="confirmation-time-header-tag">{postFix}</div>
                        <div className="confirmation-time-header-day">{this.props.date.format('dddd')}</div>
                    </div>
                </div>
                <div className="confirmation-time-container">
                    {this.renderTimes()}
                </div>
            </div>
        );
    }

    renderTimes = () => {
        const res = [];

        for (let i = this.state.startTime; i < this.state.endTime; i++) {
            let postfix = 'AM';
            let hour = i;
            if (i > 12) {
                postfix = 'PM';
                hour -= 12;
            }

            if (this.state.selectedTime !== i) {
                res.push((
                    <div className="confirmation-time-lir" key={'time_entry' + i} onClick={this.handleTimeClick.bind(this, i)}>
                        <div className="confirmation-time-formatting">{hour + ':00' + ' ' + postfix}</div>
                    </div>
                ));
            } else {
                const styleApt = {'visibility': this.state.aptType === 'apt' ? 'visible' : 'hidden'};
                const styleHomeEstimate = {'visibility': this.state.aptType === 'home-estimate' ? 'visible' : 'hidden'};
                const timeFormattingStyle = {color: '#000000'};
                res.push((
                    <div className="confirmation-time-lir" key={'time_entry' + i}>
                        <div className="confirmation-time-formatting"
                             style={timeFormattingStyle}>{hour + ':00' + ' ' + postfix}</div>
                        <div className="confirmation-time-lir-cursor confirmation-time-cursor-arrow-animation">
                            <div className="confirmation-time-cursor-arrow"/>
                            <div className="confirmation-time-cursor-block">
                                <div className="confirmation-time-cursor-radio" onClick={this.handleAptTypeClick.bind(this, 'apt')}>
                                    <div className="confirmation-time-cursor-radio-checked" style={styleApt}/>
                                </div>
                                <div className="confirmation-time-appointment-type">
                                  <FormattedMessage id="confirmationScheduleView.appointment"/>
                                </div>
                            </div>
                            <div className="confirmation-time-cursor-block">
                                <div className="confirmation-time-cursor-radio"
                                     onClick={this.handleAptTypeClick.bind(this, 'home-estimate')}>
                                    <div className="confirmation-time-cursor-radio-checked" style={styleHomeEstimate}/>
                                </div>
                                <div className="confirmation-time-appointment-type">
                                  <FormattedMessage id="confirmationScheduleView.freeHomeEstimate"/>
                                </div>
                            </div>
                        </div>
                    </div>
                ));
            }
        }

        return res;
    }
}


